import script from "./RenewLicense.vue?vue&type=script&setup=true&lang=js"
export * from "./RenewLicense.vue?vue&type=script&setup=true&lang=js"

import "./RenewLicense.vue?vue&type=style&index=0&id=8af4d954&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8af4d954"]])

export default __exports__